import React, { useEffect, useState } from "react";
import axios from "axios";
import "../Styles/Gallery.css";

function Gallery() {

  const [images, setImages] = useState([]);
  const [videos, setVideos] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {

    // Fetch photos
    axios
      .get("/api/gallery/images")
      .then((res) => {
        setImages(res.data);
      })
      .catch((err) => {
        console.error("Image fetch error:", err);
      });

    // Fetch videos
    axios
      .get("/api/gallery/videos")
      .then((res) => {
        setVideos(res.data);
      })
      .catch((err) => {
        console.error("Video fetch error:", err);
      });

  }, []);


  /* =================================
     AUTOMATIC PHOTO SLIDER
  ================================= */

  useEffect(() => {

    if (images.length <= 4) {
      return;
    }

    const timer = setInterval(() => {

      setCurrentIndex((prevIndex) => {
        return (prevIndex + 1) % images.length;
      });

    }, 3000);

    return () => clearInterval(timer);

  }, [images]);


  /* =================================
     NEXT PHOTO
  ================================= */

  const nextPhoto = () => {

    setCurrentIndex((prevIndex) => {
      return (prevIndex + 1) % images.length;
    });

  };


  /* =================================
     PREVIOUS PHOTO
  ================================= */

  const previousPhoto = () => {

    setCurrentIndex((prevIndex) => {

      return prevIndex === 0
        ? images.length - 1
        : prevIndex - 1;

    });

  };


  /* =================================
     GET 4 VISIBLE PHOTOS
  ================================= */

  const getVisibleImages = () => {

    if (images.length === 0) {
      return [];
    }

    const visibleImages = [];

    const count = Math.min(4, images.length);

    for (let i = 0; i < count; i++) {

      visibleImages.push(
        images[(currentIndex + i) % images.length]
      );

    }

    return visibleImages;
  };


  return (

    <div className="gallery-page">

      {/* =================================
          VIDEO GALLERY
      ================================= */}

      <section className="video-section">

        <div className="container">

          <h2 className="gallery-title">
            Temple Videos
          </h2>

          <div className="row mt-4">

            {videos.length === 0 ? (

              <div className="col-12 text-center">
                <p>No videos available.</p>
              </div>

            ) : (

              videos.slice(0, 3).map((video) => (

                <div
                  className="col-lg-4 col-md-6 mb-4"
                  key={video.id}
                >

                  <div className="video-box">

                    <video
                      src={`${video.fileUrl}`}
                      className="temple-video"
                      controls
                    />

                    <h5>{video.title}</h5>

                    {video.description && (
                      <p>{video.description}</p>
                    )}

                  </div>

                </div>

              ))

            )}

          </div>

        </div>

      </section>


      {/* =================================
          PHOTO GALLERY
      ================================= */}

      <section className="photo-gallery-section">

        <h2 className="gallery-title">
          Photo Gallery
        </h2>


        {images.length === 0 ? (

          <div className="text-center">
            <p>No photos available.</p>
          </div>

        ) : (

          <div className="gallery-wrapper">


            {/* LEFT ARROW */}

            {images.length > 4 && (

              <button
                className="slider-btn left"
                onClick={previousPhoto}
              >
                &#10094;
              </button>

            )}


            {/* PHOTOS */}

            <div className="gallery-row">

              {getVisibleImages().map((image, index) => (

                <div
                  className="gallery-item"
                  key={`${image.id}-${index}`}
                >

                  <img
                    src={`${image.fileUrl}`}
                    alt={image.title || "Temple Gallery"}
                  />

                </div>

              ))}

            </div>


            {/* RIGHT ARROW */}

            {images.length > 4 && (

              <button
                className="slider-btn right"
                onClick={nextPhoto}
              >
                &#10095;
              </button>

            )}

          </div>

        )}

      </section>

    </div>

  );
}

export default Gallery;